// @flow

import * as React from 'react';
import ReactFetchComponent from './react-fetch-component';
import request from 'db-request';

export type FetchResult<T> = {
  loading: boolean,
  error: any,
  data: T,
  clearData: () => void,
};

type Props = {
  url: string,
  options: { [string]: any },
  cache: boolean,
  manual: boolean,
  onChange: (props: FetchResult<any>) => void,
  children: (props: FetchResult<any>) => React.Node,
};

type DataProps = {
  ...Props,
  data: { [string]: any },
};

const Get = (props: Props) => {
  const getFunction = () => {
    return request.get(props.url, props.options);
  };

  return <ReactFetchComponent fetchFunction={getFunction} {...props} />;
};

const Post = (props: DataProps) => {
  const postFunction = () => {
    return request.post(props.url, props.data, props.options);
  };

  return <ReactFetchComponent fetchFunction={postFunction} {...props} />;
};

const Fetch = (props: Props) => (
  <ReactFetchComponent {...props} fetchFunction={request.call} />
);

Fetch.Post = Post;
Fetch.Get = Get;

export default Fetch;
